import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'view-image-dialog',
    template: `
        <h1 mat-dialog-title>{{ this.data.titel ? this.data.titel : 'Screenshot' }}</h1>
        <div mat-dialog-content>
            <img [src]="data.imageSrc" alt="Großansicht" style="width: 100%; height: auto;" />
        </div>
        <div align="end" mat-dialog-actions>
            <button (click)="dialogRef.close()" mat-button>Schließen</button>
        </div>
    `,
})
export class ViewImageDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { imageSrc: string; titel: string },
        public dialogRef: MatDialogRef<ViewImageDialogComponent>,
    ) {}
}
